/** Label lookup for GHG emission scope keys used in breakdown tables. */
export const ghgScopesNb: Record<string, string> = {
  scope1: "Scope 1",
  scope2: "Scope 2",
  scope3: "Scope 3",
}
